module.exports = __webpack_public_path__ + "static/media/coding.1fcbdfba.jpg";